import { useNavigate, useParams } from '@exam-center/router';
import { dayjs } from '@shared/utils';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export default function ExamEventLayout() {
  const { year, examCenterCode } = useParams('/:examCenterCode/exam-events/years/:year');
  const navigate = useNavigate();

  useEffect(() => {
    if (isNaN(parseInt(year))) {
      const currentYear = dayjs().year();

      navigate('/:examCenterCode/exam-events/years/:year', {
        replace: true,
        params: {
          year: currentYear.toString(),
          examCenterCode,
        },
      });
    }
  }, [navigate, year]);

  return <Outlet />;
}
